import { useCallback } from "react";
import Next from "./Next.js";
import Score from "./Score.js";
import Level from "./Level.js";
import { createMatrix } from "../helpers/Helpers";
import React, { useState, useEffect } from "react";
import styles from "./Game.module.css";
import { emtpyPiece } from "../tetris/Piece";
import arrowRight from "../img/Vector.svg";
import arrowLeft from "../img/Vector (1).svg";
import rotate from "../img/gnome-session-reboot-svgrepo-com 1.svg";
import bottom from "../img/Layer 2.svg";
import doubleBottom from "../img/Vector (2).85f298c6.svg";

import { localizations, getLanguage } from "./localization";
export const Game = (props) => {
  const tetris = props.tetris;
  const [dimensions, setDimensions] = useState({
    w: document.documentElement.clientWidth,
    h: document.documentElement.clientHeight,
  });
  const [state, setState] = useState(props.tetris.state);

  const handleResize = () => {
    setDimensions({
      w: document.documentElement.clientWidth,
      h: document.documentElement.clientHeight,
    });
  };

  const onStateChange = (_state) => {
    setState(_state);
  };

  useEffect(() => {
    tetris.onStateChange(onStateChange);
  }, [tetris]);

  let resumePauseButton;
  if (state.isStarted()) {
    if (state.isRunning()) {
      resumePauseButton = (
        <button
          onClick={tetris.pause}
          className={`${styles.btn} ${styles.btnPause}`}
        ></button>
      );
    } else {
      resumePauseButton = (
        <button
          onClick={tetris.resume}
          className={`${styles.btn} ${styles.btnContinue}`}
        ></button>
      );
    }
  }

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [handleResize]);

  const reStart = useCallback(() => {
    window.ysdk.features.GameplayAPI.stop();
    window.ysdk.adv.showFullscreenAdv({
      callbacks: {
        onClose: function (wasShown) {
          window.ysdk.features.GameplayAPI.start();
          tetris.start(true);
        },
        onError: function (error) {},
      },
    });
  }, [tetris]);

  const resume = useCallback(() => {
    window.ysdk.features.GameplayAPI.stop();
    window.ysdk.adv.showFullscreenAdv({
      callbacks: {
        onClose: function (wasShown) {
          window.ysdk.features.GameplayAPI.start();
          tetris.start();
        },
        onError: function (error) {},
      },
    });
  }, [tetris]);

  const matrix = createMatrix(state.visibleMatrix(), styles);

  const nextPiece = state.nextPiece();
  const visibleNextPiece = nextPiece ? nextPiece : emtpyPiece();

  const gameOver = state.isGameOver() ? (
    <div className={styles.gameOver}>
      <div className={styles.gameOverWrapper}>
        <div className={styles.gameOverTitle}>
          {localizations.congratulations[getLanguage()]}
        </div>
        <div className={styles.gameOverLevel}>
          {localizations.level[getLanguage()]}:&nbsp;{state.level()}
        </div>
        <div className={styles.gameOverLevel}>
          {localizations.score[getLanguage()]}:&nbsp;{state.score()}
        </div>
        <div className={styles.gameOverButton} onClick={resume}>
          {localizations.startOver[getLanguage()]}
        </div>
      </div>
    </div>
  ) : (
    ""
  );
  return (
    <div
      className={styles.topContainer}
      style={(() => {
        var width = dimensions.w;
        var height = dimensions.h;
        var ratio = (height / width).toFixed(1);
        var scale;
        if (ratio <= 1.6) {
          scale = height / 670;
        } else {
          scale = width / 480;
        }
        return { transform: "scale(".concat(scale, ")") };
      })()}
    >
      <div className={styles.content}>
        <div></div>

        <div className={styles.matrix}>
          {matrix}
          {gameOver}
        </div>
        <div className={styles.buttonsWrapper}>
          <div className={styles.buttons}>
            <div className={styles.button} onClick={props.handleArrowLeft}>
              <img src={arrowLeft} />
            </div>
            <div className={styles.button} onClick={props.handleArrowRight}>
              <img src={arrowRight} />
            </div>
            <div className={styles.button} onClick={props.handleArrowBottom}>
              <img src={doubleBottom} />
            </div>
          </div>
        </div>
        <div className={styles.controls}>
          <div className={styles.controlsNext}>
            <Next next={visibleNextPiece} />
          </div>
          <div className={styles.controlsScore}>
            <Score score={state.score()} />
          </div>
          <div className={styles.controlsLevel}>
            <Level level={state.level()}></Level>
          </div>
          <div className={styles.controlsButtons}>
            <div className={styles.row}>
              <button
                onClick={reStart}
                className={`${styles.btn} ${styles.btnNew}`}
              ></button>
            </div>
            <div className={styles.row}>{resumePauseButton}</div>
          </div>
          <div className={styles.controlsInfo}>
            <p class="infoText"></p>
          </div>
        </div>
        <div className={styles.buttonsWrapperRight}>
          <div className={styles.buttons}>
            <div
              className={styles.button}
              onClick={() => tetris.isRunning() && tetris.hardDrop()}
            >
              <img src={bottom} />
            </div>
            <div className={styles.button} onClick={props.handleArrowRotate}>
              <img src={rotate} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Game;
